import { render, staticRenderFns } from "./ExaminationDetailPage.vue?vue&type=template&id=dca3f65a&scoped=true&"
import script from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
export * from "./ExaminationDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationDetailPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExaminationDetailPage.vue?vue&type=style&index=1&id=dca3f65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca3f65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VSpacer,
})
